import axios from "axios";
import React from "react";

let Elink = new URLSearchParams(window.location.search).get('elink'); // Fetch unique(EstimateKey or elink) from Url.
let EmployeeKey = new URLSearchParams(window.location.search).get('employee'); // Fetch unique(EstimateKey or elink) from Url.
let For = new URLSearchParams(window.location.search).get('goto'); // Fetch 'goto' param from Url to know which page to show.
let BASE_URL = process.env.REACT_APP_BASE_URL // Automatically Fetch Base Url from env file according to Environment.
let suffixUrl = process.env.REACT_APP_SUFFIX_URL
let protocol = process.env.REACT_APP_REQUEST
let FetchEstimateRecordsUrl = `` // Url for Fetch Records for Estimate.
let SaveEstPortalSignUrl = `` // Url to save Est Sign from portal.
let PayDepsoitUrl = `` // Url for Pay Deposit from portal.
let PayInvoiceDepsoitUrl = `` // Url for Pay Invoice Deposit from portal.
let UpdatePackingMaterialsUrl = `` // Url to Update Packing Materials for Estimate.
let FetchEstimateInventoriesUrl = `` // Url to fetch Inventories for Est.
let UpdateInventoriesUrl = `` // Url to Update Inventories for Estimate.
let FetchContactPersonsUrl = `` // Url to fetch Contact Persons for Est.
let UpdateContactPersonsUrl = `` // Url to Update Contact Persons for Estimate.
let UpdateRelocationUrl = `` // Url to Update Relocation Insurance for Estimate.
let FetchClientInvoice2RecordsUrl = `` // Url to Fetch CP-Invoice-2 records for Estimate.
let FetchIV2_PageDetails = `` // Url to Fetch CP-Invoice-1 records for Estimate.
let FetchInvoiceTypeUrl = `` // Url to fetch invoice type.
let SaveEsignsForPortal = `` // Url to save signatures(short code).
let SaveEstimateAddendumValues = `` // Url to create estimate room.
let SaveEstimateTagValues = `` // Url to create estimate room.
let RemoveClientPortalSign = `` //Url to remove client portal signature
let PrintClientPortalPdf = `` //url to print pdf
let RequestMoveDate = `` // url to update service date or move date of the estimate
let DeclineEstimateUrl = `` // url for decline estimate
let CreateEstimateDuplicate = ``
let EditCurrentEstimate =  ``
let UploadImageUrl =  ``
let DeleteEsignUrl =  ``
let FetchExtraStopAddresses =   ``
let UpdateAddresses = ``
let SaveRadioButtonsValue = ``
let FetchEstimateDetailRecordsUrl = ``
let FetchEstimateDefaultRoomRecordsUrl = ``
let UpdateDefaultRoomInventoryUrl = ``
let CreateCustomInventoryEstimateUrl = ``
let CreateBedrooms = ``
let FetchAllEstimateRoomsUrl = ``
let FetchEstimateRoomInventoryUrl = ``
let UpdateRoomFloorUrl = ``
let DeleteEstimateRoomUrl = ``
let RenameRoomUrl = ``
let FetchRoomCategoriesUrl = ``
let CreateNewRoomUrl = ``
let FetchEstimateRoomsAndInventoriesUrl = ``
let FetchCompanyInventoriesUrl = ``
let UpdateRoomInventoryUrl = ``
let UploadInventoryOrRoomImagesUrl = ``
let LastPageVisited = ``
let FetchEstimateRoomPicturesUrl = ``
let DeleteImageUrl = ``
let DeleteInventoryEstimateUrl = ``
let ClientPortalUrl = ``
let UpdateTipUrl = ``
let UpdateEmpArrivalTime = ``
let FetchRoomsWithMoveSize = ``
let CompanySubdomain
// get and set base url with company subdomain
let SaveClientPortalAddendum = `` // Url to submit addendum data
let UnsubmitAddendumData = `` // Url to unsubmit addendum data
let DeleteAddendumSign = `` // Url to delete addendum sign
let FetchStorageRecordsUrl = `` // Url to fetch Storage Portal records.
// Storage specific action endpoints (placeholders; to be set dynamically similarly to others in Subdomain())
let ShowStorageAddendumUrl = `` // POST show_addendum
let SubmitStorageAddendumUrl = `` // POST submit_addendum
let RemoveStorageSignatureUrl = `` // POST remove_storage_signature
let StorageSignaturePadUrl = `` // GET storage_signature/:id
let PrintStorageUrl = `` // print_storage_portal
let SaveStorageSignatureUrl = `` // POST save_storage_signature (customer storage signature)
let SaveStorageAddendumSignatureUrl = `` // POST storage_addendum_signature (signature for addendum content)
let PayStoragePayment = `` // Url to pay storage payment
let CreateCreditCard = `` // Url to create credit card for storage payment
let UpdateCustomerStorageCreditCard = `` // Url to update customer storage credit card
let PayNowForStorage = `` // Url to update customer storage credit card
let UnsubmitStorageAddendumData = "" // Url to unsubmit storage addendum data
let StorageIvnetoriesUrl = "" // Url to unsubmit storage addendum data
let UpdateStorageContactPersonsUrl = "" // Url to unsubmit storage addendum data
const Subdomain = async () => {
    // code to make base URL dynamic acc to estimate subdomain
    let cookie = document.cookie
    cookie = cookie.split('employee_id=')[1]
    let url = For != "storage" ?  `${BASE_URL}get_company_subdomain` : `${BASE_URL}get_storage_company_subdomain`
    let params = For != "storage" ? {estimate_key: Elink, employee_key: cookie, For: For} : {Storage_key: Elink, employee_key: cookie, For: For}
    await axios({method: 'post', url: url, params: params})
        .then((result) => {
            let subdomain = result.data
            CompanySubdomain = subdomain
            FetchEstimateRecordsUrl = `${protocol}${subdomain}${suffixUrl}fetch_estimate_records`
            SaveEstPortalSignUrl = `${protocol}${subdomain}${suffixUrl}/save_estimate_portal_sign`
            PayDepsoitUrl = `${protocol}${subdomain}${suffixUrl}/pay_deposit`
            PayInvoiceDepsoitUrl = `${protocol}${subdomain}${suffixUrl}pay_invoice_deposit`
            UpdatePackingMaterialsUrl = `${protocol}${subdomain}${suffixUrl}update_packing_materails`
            FetchEstimateInventoriesUrl = `${protocol}${subdomain}${suffixUrl}fetch_estimate_inventories`
            FetchRoomsWithMoveSize = `${protocol}${subdomain}${suffixUrl}rooms_with_move_size`
            UpdateInventoriesUrl = `${protocol}${subdomain}${suffixUrl}update_inventories`
            FetchContactPersonsUrl = `${protocol}${subdomain}${suffixUrl}fetch_contact_persons`
            UpdateContactPersonsUrl = `${protocol}${subdomain}${suffixUrl}update_contact_persons`
            UpdateRelocationUrl = `${protocol}${subdomain}${suffixUrl}update_relocation_insurance`
            FetchClientInvoice2RecordsUrl = `${protocol}${subdomain}${suffixUrl}fetch_client_invoice2_records`
            FetchIV2_PageDetails = `${protocol}${subdomain}${suffixUrl}fetch_digital_invoice_details`
            FetchInvoiceTypeUrl = `${protocol}${subdomain}${suffixUrl}fetch_invoice_type`
            SaveEsignsForPortal = `${protocol}${subdomain}${suffixUrl}save_esigns_for_portal`
            SaveEstimateAddendumValues = `${protocol}${subdomain}${suffixUrl}save_estimate_addendum_values`
            SaveEstimateTagValues = `${protocol}${subdomain}${suffixUrl}update_tag_values`
            RemoveClientPortalSign = `${protocol}${subdomain}${suffixUrl}remove_client_portal_sign`
            PrintClientPortalPdf = `${protocol}${subdomain}${suffixUrl}print_client_portal_pdf`
            RequestMoveDate = `${protocol}${subdomain}${suffixUrl}request_to_move_date`
            DeclineEstimateUrl = `${protocol}${subdomain}${suffixUrl}decline_estimate`
            CreateEstimateDuplicate = `${protocol}${subdomain}${suffixUrl}create_estimate_duplicate`
            EditCurrentEstimate =  `${protocol}${subdomain}${suffixUrl}edit_current_estimate`
            UploadImageUrl =  `${protocol}${subdomain}${suffixUrl}upload_image`
            DeleteEsignUrl =  `${protocol}${subdomain}${suffixUrl}delete_esign`
            FetchExtraStopAddresses =   `${protocol}${subdomain}${suffixUrl}fetch_extra_stop_addresses_details`
            UpdateAddresses = `${protocol}${subdomain}${suffixUrl}update_estimate_addresses`
            SaveRadioButtonsValue = `${protocol}${subdomain}${suffixUrl}save_radio_button_value`
            FetchEstimateDetailRecordsUrl = `${protocol}${subdomain}${suffixUrl}fetch_estimate_details`
            FetchEstimateDefaultRoomRecordsUrl = `${protocol}${subdomain}${suffixUrl}fetch_estimate_default_room`
            UpdateDefaultRoomInventoryUrl = `${protocol}${subdomain}${suffixUrl}update_default_room_inventories`
            CreateCustomInventoryEstimateUrl = `${protocol}${subdomain}${suffixUrl}create_custom_inventory_estimate`
            CreateBedrooms = `${protocol}${subdomain}${suffixUrl}create_bedrooms`
            FetchAllEstimateRoomsUrl = `${protocol}${subdomain}${suffixUrl}fetch_all_estimate_rooms`
            FetchEstimateRoomInventoryUrl = `${protocol}${subdomain}${suffixUrl}fetch_estimate_room_inventories`
            UpdateRoomFloorUrl = `${protocol}${subdomain}${suffixUrl}update_room_floor`
            DeleteEstimateRoomUrl = `${protocol}${subdomain}${suffixUrl}delete_room_estimate`
            RenameRoomUrl = `${protocol}${subdomain}${suffixUrl}rename_room`
            FetchRoomCategoriesUrl = `${protocol}${subdomain}${suffixUrl}fetch_room_categories`
            CreateNewRoomUrl = `${protocol}${subdomain}${suffixUrl}create_new_room`
            FetchEstimateRoomsAndInventoriesUrl = `${protocol}${subdomain}${suffixUrl}fetch_estimate_rooms_and_inventories`
            FetchCompanyInventoriesUrl = `${protocol}${subdomain}${suffixUrl}fetch_company_inventories`
            UpdateRoomInventoryUrl = `${protocol}${subdomain}${suffixUrl}update_room_inventory`
            UploadInventoryOrRoomImagesUrl = `${protocol}${subdomain}${suffixUrl}upload_inventory_or_room_images`
            LastPageVisited = `${protocol}${subdomain}${suffixUrl}update_last_page_visited`
            FetchEstimateRoomPicturesUrl = `${protocol}${subdomain}${suffixUrl}fetch_estimate_room_pictures`
            DeleteImageUrl = `${protocol}${subdomain}${suffixUrl}delete_image`
            DeleteInventoryEstimateUrl = `${protocol}${subdomain}${suffixUrl}delete_inventory_estimate`
            ClientPortalUrl = `${protocol}${subdomain}${suffixUrl}client_portal_url`
            UpdateTipUrl = `${protocol}${subdomain}${suffixUrl}update_tip_url`
            UpdateEmpArrivalTime = `${protocol}${subdomain}${suffixUrl}update_emp_arrival_time`
            SaveClientPortalAddendum = `${protocol}${subdomain}${suffixUrl}save_client_portal_addendum`
            UnsubmitAddendumData = `${protocol}${subdomain}${suffixUrl}unsubmit_addendum_data`
            DeleteAddendumSign = `${protocol}${subdomain}${suffixUrl}delete_addendum_signature`
            FetchStorageRecordsUrl = `${protocol}${subdomain}${suffixUrl}fetch_storage_records`
            ShowStorageAddendumUrl = `${protocol}${subdomain}${suffixUrl}show_storage_addendum`
            SubmitStorageAddendumUrl = `${protocol}${subdomain}${suffixUrl}submit_storage_addendum`
            RemoveStorageSignatureUrl = `${protocol}${subdomain}${suffixUrl}remove_storage_signature`
            StorageSignaturePadUrl = `${protocol}${subdomain}${suffixUrl}storage_signature`
            PrintStorageUrl = `${protocol}${subdomain}${suffixUrl}print_storage_portal`
            SaveStorageSignatureUrl = `${protocol}${subdomain}${suffixUrl}save_signature_image`
            SaveStorageAddendumSignatureUrl = `${protocol}${subdomain}${suffixUrl}storage_addendum_signature`
            PayStoragePayment = `${protocol}${subdomain}${suffixUrl}pay_storage_payment`
            CreateCreditCard = `${protocol}${subdomain}${suffixUrl}create_credit_card`
            UpdateCustomerStorageCreditCard = `${protocol}${subdomain}${suffixUrl}update_customer_storage_credit_card`
            PayNowForStorage = `${protocol}${subdomain}${suffixUrl}pay_now_for_storage`
            UnsubmitStorageAddendumData = `${protocol}${subdomain}${suffixUrl}unsubmit_storage_addendum_data`
            StorageIvnetoriesUrl = `${protocol}${subdomain}${suffixUrl}storage_inventories`
            UpdateStorageContactPersonsUrl = `${protocol}${subdomain}${suffixUrl}update_storage_contact_persons`
        })
}

export {
    Subdomain,
    CompanySubdomain,
    FetchEstimateRecordsUrl,
    Elink,
    EmployeeKey,
    For,
    SaveEstPortalSignUrl,
    PayDepsoitUrl,
    PayInvoiceDepsoitUrl,
    UpdatePackingMaterialsUrl,
    FetchEstimateInventoriesUrl,
    FetchRoomsWithMoveSize,
    UpdateInventoriesUrl,
    FetchContactPersonsUrl,
    UpdateContactPersonsUrl,
    UpdateRelocationUrl,
    FetchClientInvoice2RecordsUrl,
    FetchIV2_PageDetails,
    FetchInvoiceTypeUrl,
    SaveEsignsForPortal,
    SaveEstimateAddendumValues,
    SaveEstimateTagValues,
    RemoveClientPortalSign,
    PrintClientPortalPdf,
    RequestMoveDate,
    DeclineEstimateUrl,
    CreateEstimateDuplicate,
    EditCurrentEstimate,
    UploadImageUrl,
    DeleteEsignUrl,
    FetchExtraStopAddresses,
    UpdateAddresses,
    SaveRadioButtonsValue,
    FetchEstimateDetailRecordsUrl,
    FetchEstimateDefaultRoomRecordsUrl,
    UpdateDefaultRoomInventoryUrl,
    CreateCustomInventoryEstimateUrl,
    CreateBedrooms,
    FetchAllEstimateRoomsUrl,
    FetchEstimateRoomInventoryUrl,
    UpdateRoomFloorUrl,
    DeleteEstimateRoomUrl,
    RenameRoomUrl,
    FetchRoomCategoriesUrl,
    CreateNewRoomUrl,
    FetchEstimateRoomsAndInventoriesUrl,
    FetchCompanyInventoriesUrl,
    UpdateRoomInventoryUrl,
    UploadInventoryOrRoomImagesUrl,
    LastPageVisited,
    FetchEstimateRoomPicturesUrl,
    DeleteImageUrl,
    DeleteInventoryEstimateUrl,
    ClientPortalUrl,
    UpdateTipUrl,
    UpdateEmpArrivalTime,
    SaveClientPortalAddendum,
    UnsubmitAddendumData,
    DeleteAddendumSign,
    FetchStorageRecordsUrl,
    ShowStorageAddendumUrl,
    SubmitStorageAddendumUrl,
    RemoveStorageSignatureUrl,
    StorageSignaturePadUrl,
    PrintStorageUrl,
    SaveStorageSignatureUrl,
    SaveStorageAddendumSignatureUrl,
    PayStoragePayment,
    CreateCreditCard,
    UpdateCustomerStorageCreditCard,
    PayNowForStorage,
    UnsubmitStorageAddendumData,
    StorageIvnetoriesUrl,
    UpdateStorageContactPersonsUrl
} ;
